<template>
  <div
    class="h-screen flex vx-row items-center justify-center bg-auth"
    :class="{'w-full no-gutter': !isDesktop}"
    id="page-login"
  >
    <div class="mobile-btn-back">
      <button v-if="!isDesktop" @click="onClose" class="btn-close">
        <feather-icon icon='XIcon'/>
      </button>
    </div>

    <div class="h-full">
      <div class="items-center w-full">
        <div slot="no-body" class="full-page-bg-color">
          <div class="login-body">
            <div class="vx-col lg:block lg:w-1/1 logo-click" @click="onClose">
              <vx-tooltip text="Clique para voltar" position="bottom" delay=".1s">             
                <div class="logo-login mx-auto" :class="{'logo-login-mobile': !isDesktop}"></div>
              </vx-tooltip>
            </div>

            <div class="w-full center">
              <h3 class="mb-4">{{$t('DOWNLOAD_PUBLIC_FILE_EMAIL').Title}}</h3>
            </div>

            <div class="pagecard">
              <div
                @click="onDowload"
                class="cursor-pointer center"
              >
                <img src="@/assets/images/pages/login/download.svg" alt="login" class="mx-auto" />
              </div>
              <div class="vx-col mx-auto self-center d-theme-dark-bg">
                <div class="p-8">
                  <div class="mb-8">
                    <!-- <h4 class="mb-4">{{$t('DOWNLOAD_PUBLIC_FILE_EMAIL').Title}}</h4> -->
                    <div class="flex p-2" v-if="reportType">
                      <feather-icon
                        icon="ActivityIcon"
                        class="mr-4"
                        svg-classes="w-6 h-6"
                      ></feather-icon>
                      <p>{{reportType}}</p>
                    </div>
                    <div class="flex p-2" v-if="filename">
                      <feather-icon
                        icon="FileTextIcon"
                        class="mr-4"
                        svg-classes="w-6 h-6"
                      ></feather-icon>
                      <p>{{filename}}</p>
                    </div>
                  </div>
                  <!-- <div class="flex flex-wrap justify-between flex-col-reverse sm:flex-row mt-5"> -->
                  <div class="mt-2">
                    <vs-button
                      @click="onDowload"
                      class="px-4 w-full"
                    >{{$t('BUTTONS').DownloadFile}}</vs-button>
                    <!-- <vs-button
                      type="border"
                      class="px-4 w-full md:w-auto"
                      @click="onClose"
                    >{{$t('BUTTONS').BackHomePage}}</vs-button> -->
                  </div>
                </div>
              </div>
            </div>

            <auth-footer-privacy
              @open-terms="displayPopupTermsCondition = !displayPopupTermsCondition"
              @open-privacy="displayPolicyPage = !displayPolicyPage"
            ></auth-footer-privacy>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userService from "../../providers/userService";
import messagesNotifyHelper from "../../helpers/messages-notify-helper";
import reportService from "../../providers/reportService";
import jwt_decode from "jwt-decode";
import AppConstants from '../../appConstants';
import AuthFooterPrivacy from './AuthFooterPrivacy.vue';

export default {
  components: {
    AuthFooterPrivacy

  },
  data() {
    return {
      token: '',
      reportType: '',
      filename: '',
      reportId: '',
      isConsulting: false
    };
  },
  computed: {
    isDesktop() {
      return this.$store.state.isDesktop;
    },
  },
  mounted() {
    this.token = this.$route.query.token;

    if (!this.token) {
      messagesNotifyHelper.errorNotify(this.$t('DOWNLOAD_PUBLIC_FILE_EMAIL').Notify_Error_Title, this.$t('DOWNLOAD_PUBLIC_FILE_EMAIL').Notify_Error_Message_Token_Not_Found);
      return;
    }

    const jwtDecode = jwt_decode(this.token);

    if (!jwtDecode.filename) {
      messagesNotifyHelper.errorNotify(this.$t('DOWNLOAD_PUBLIC_FILE_EMAIL').Notify_Error_Title, this.$t('DOWNLOAD_PUBLIC_FILE_EMAIL').Notify_Error_Message_Invalid_Token);
      return;
    }

    this.reportType = jwtDecode.reportType || '';
    this.filename = jwtDecode.filename;
    this.isConsulting = jwtDecode.isConsulting;
    this.reportId = jwtDecode.reportId;
  },
  methods: {
    onClose() {
      this.$router.push(AppConstants.NAVIGATION_PAGE_HOME);
    },
    onDowload() {
      // console.log("ondownload");
      const params = new URLSearchParams();
      // params.append("token", this.token);
      params.append("download", true);
      // params.append("token", this.token);
      // if (this.isConsulting) {
      //   params.append("isConsulting", true);
      // }
      reportService
        .readDocumentFile(this.reportId, params)
        .then(response => {
          const bytes = this.CryptoJS.AES.decrypt(response.data, AppConstants.PDF_PWD);
          const pdfPlain = bytes.toString(this.CryptoJS.enc.Utf8);
          const pdfData = Buffer.from(pdfPlain, 'base64');
          console.log(pdfData);

          const url = window.URL.createObjectURL(new Blob([pdfData]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", this.filename);
          link.setAttribute("id", "link-download");
          document.body.appendChild(link);
          link.click();
          document.getElementById("link-download").remove();
          
        })
        .catch(error => {
          console.log(error);
        });
      // reportService
      //   .downloadReportFile(`${BASE_URL}/upload/documents/${this.filename}`,params)
      //   .then(response => {
      //     const url = window.URL.createObjectURL(new Blob([response.data]));
      //     const link = document.createElement("a");

      //     link.href = url;
      //     link.setAttribute("download", this.filename);
      //     link.setAttribute("id", "link-download");

      //     document.body.appendChild(link);
      //     link.click();

      //     document.getElementById("link-download").remove();
      //   })
      //   .catch(error => {
      //     console.log(error);
      //   });
      // reportService
      //   .downloadPublicFile(params)
      //   .then(response => {
      //     const url = window.URL.createObjectURL(new Blob([response.data]));
      //     const link = document.createElement("a");

      //     link.href = url;
      //     link.setAttribute("download", this.filename);
      //     link.setAttribute("id", "link-download");

      //     document.body.appendChild(link);
      //     link.click();

      //     document.getElementById("link-download").remove();
      //   })
      //   .catch(error => {
      //     console.log(error);
      //   });
    }
  }
};
</script>
<style lang="scss">
.download-link {
  text-decoration: underline;
  font-size: 16px;
  font-weight: 500;
}
img.mx-auto {
  width: 150px;
}
</style>
